import React from 'react';
import alert from '../assets/alert.png';


const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm,deleteConfirm }) => {
  return (
    isOpen && (
      <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
      <div className='bg-white rounded-lg shadow-lg w-[30%] p-6 relative'>
        {/* Alert image centered above text */}
        <div className='flex justify-center mb-4'>
          <img src={alert} alt="Alert" className='h-10 w-10' />
        </div>
          <h4>Are you sure, you want to delete {deleteConfirm} user?</h4>
          <button onClick={onConfirm} className='bg-red-600 mt-4  mx-4 text-white px-4 py-1 text-[14px] rounded'>
            Yes, Delete
          </button>
          <button onClick={onClose} className='bg-gray-300 mt-4 mx-4 text-black px-4 py-1 text-[14px] rounded'>
            Cancel
          </button>
        </div>
      </div>
    )
  );
};

export default DeleteConfirmationModal;
